export function homeNews() {
  const homeNews = document.querySelectorAll('.js-home-news');
  if(homeNews.length) {
    for (let i = 0; i < homeNews.length; i++) {
      const el = homeNews[i];
      const a = el.querySelectorAll('a');
      const image = el.querySelector('.js-home-news-image');
      const credit = el.querySelector('.js-home-news-credit');
    
      if(homeNewsDesign) {
        const data = homeNewsDesign.data;
        const update = () => {
          const today = new Date();
          const h = today.getHours();
          for (let i = 0; i < data.length; i++) {
            const current = data[i];
            if(current.start && current.end) {
              if((h >= current.start) && (h < current.end)) {

                if(current.bgColor) {
                  el.style.backgroundColor = current.bgColor;
                } else {
                  el.style.backgroundColor = '';
                }

                if(current.textColor) {
                  el.style.color = current.textColor;
                  if(a){
                    for (let i = 0; i < a.length; i++) {
                      const el = a[i];
                      el.style.color = current.textColor;
                    }
                  }
                } else {
                  el.style.color = '';
                  if(a){
                    for (let i = 0; i < a.length; i++) {
                      const el = a[i];
                      el.style.color = '';
                    }
                  }
                }

                if(current.image && image) {
                  image.style.backgroundImage = `url(${current.image})`;
                } else {
                  image.style.backgroundImage = '';
                }

                if(current.credit && credit) {
                  credit.innerHTML = current.credit;
                  credit.classList.remove('hide');
                  if(current.creditUrl) {
                    credit.setAttribute('href', current.creditUrl);
                    credit.classList.remove('is-disable');
                  } else {
                    credit.classList.add('is-disable');
                  }
                } else {
                  credit.innerHTML = '';
                  credit.setAttribute('href', '');
                  credit.classList.add('hide', 'is-disable');
                }

              }
            }
          }
        }
        update();
        setInterval(update, 1000);
      }
    }
  }
}